import { Component, OnInit } from '@angular/core';
import { jsonResponseApi } from 'src/app/shared/models/json-response.model';
import { user } from 'src/app/shared/models/user.model';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  constructor(private service: CommonService) {}

  user: user;

  ngOnInit(): void {
    this.getUser();
  }

  getUser(): void {
    const url = 'cross/user';
    this.service.get(url).then((data: jsonResponseApi) => {
      this.user = this.service.jsonParse(data);
    });
  }
}
